import { withLeadingHashPrefix } from "./locationHash";

interface BuildLocationHrefParams {
  hash?: string;
  pathname: string;
  search?: string;
}

const withLeadingSearchPrefix = (search?: string) => {
  if (!search) return "";
  return search.startsWith("?") ? search : `?${search}`;
};

/**
 * @deprecated Do not use for new TanStack Router routes. Prefer TSR's typed
 * `navigate({ search })` or `useUpdateQueryParam` without `keepPlainQueryString`.
 * This helper exists only for legacy routes that must preserve React Router-style
 * plain query string serialization.
 */
export const buildLocationHref = ({
  pathname,
  search,
  hash,
}: BuildLocationHrefParams): string => {
  const querySuffix = withLeadingSearchPrefix(search);
  const hashSuffix = withLeadingHashPrefix(hash);

  return `${pathname}${querySuffix}${hashSuffix}`;
};
